import { render } from "./PoliticaDePrivacidade.vue?vue&type=template&id=1aa78109"
import script from "./PoliticaDePrivacidade.vue?vue&type=script&lang=js"
export * from "./PoliticaDePrivacidade.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gabrielalencar/Documents/custom/gestio-school-frontend-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__